import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getDrillDownQuizReport = (
  classId,
  pageNumber = 1,
  pageSize = 20,
  reportMode
) => {
  cancelToken = getAxiosCancelToken(cancelToken);

  if (reportMode === "View") {
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.QUIZ_REPORT.GET_DRILLDOWN_QUIZ_REPORT(
        classId,
        (pageNumber = 1),
        (pageSize = 20),
        reportMode
      ),
      "",
      cancelToken
    );
  } else {
    let url =
      encodeURIComponent(apiConstants.BASE_URL_1) +
      encodeURIComponent(
        apiConstants.REPORT.QUIZ_REPORT.GET_DRILLDOWN_QUIZ_REPORT(
          classId,
          (pageNumber = 0),
          (pageSize = 0),
          reportMode
        )
      );
    let template = "DrillDownReport";
    return apiRequestType(
      apiTypes.GET,
      apiConstants.REPORT.CSV_REPORT(url, template),
      "",
      cancelToken
    );
  }
};

export default getDrillDownQuizReport;
